import { render, staticRenderFns } from "./dictMgr.vue?vue&type=template&id=38cdf4c1"
import script from "./dictMgr.vue?vue&type=script&lang=js"
export * from "./dictMgr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports